<template>
  <v-message-page
    :msg="message"
    msg-type="info"
    :translate-text="false"
    icon="info"
  />
</template>

<script>
import MessagePage from '@/common/components/MessagePage.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'MaxReviews',
  computed: {
    ...mapGetters(['user']),
    message() {
      let maxCount = 10;
      if (this.user.config) {
        maxCount = this.user.config.reviews_per_hour;
      }
      return this.$t('sentence.max_reviews', { maxCount, time: this.getNextHour() });
    },
  },
  methods: {
    getNextHour() {
      const hours = new Date().getHours();
      if (hours === 23) {
        return '00:00';
      }
      return `${hours + 1}:00`;
    },
  },
  components: {
    'v-message-page': MessagePage,
  },
};
</script>
